import type { PropsWithChildren } from 'react';
import type React from 'react';

import { MediaHitsContextBaseProvider } from './context';
import { useMediaHitsContextValue } from './useMediaHitsContextValue';

export const MediaHitsContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
	const value = useMediaHitsContextValue();

	return <MediaHitsContextBaseProvider value={value}>{children}</MediaHitsContextBaseProvider>;
};
